import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './error-pages.scss';

const ServerErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__brand">RealityCoach</div>

        <div className="error-page__code error-page__code--red">500</div>

        <h1 className="error-page__title">{t('errorPages.internalServerError')}</h1>

        <p className="error-page__description">
          {t('errorPages.serverErrorDescription')}
        </p>

        <div className="error-page__actions">
          <button className="error-page__btn-primary" onClick={() => window.location.reload()}>
            {t('errorPages.tryAgain')}
          </button>
          <button className="error-page__btn-secondary" onClick={() => navigate('/')}>
            {t('errorPages.goToDashboard')}
          </button>
        </div>

        <div className="error-page__info-box error-page__info-box--error">
          <p>
            {t('errorPages.problemPersists')}
          </p>
        </div>

        <p className="error-page__footer">{t('errorPages.serverErrorCode')}</p>
      </div>
    </div>
  );
};

export default ServerErrorPage;
